import React from 'react';
import PropTypes from 'prop-types';

const GraphicsItem = ({ icon, title, description, dir, alt }) => {
  return (
    <>
      <style>{`
        .graphics-item { display: flex; gap: 12px; align-items: flex-start; minWidth: 250px; margin-left: 0px; }
        .graphics-item img { width: 38px; height: 38px; object-fit: contain; align-self: flex-start; margin-top: -10px; }
        .graphics-item .g-title { font-size: 19px; font-weight: 600; color: #111; margin-bottom: 10px; text-align: left; }
        .graphics-item .g-desc { font-size: 16px; font-weight: 400; color: #858e9d; text-align: left; }
        @media (max-width: 992px) {
          .graphics-item .g-title { font-size: 18px; }
          .graphics-item .g-desc { font-size: 15px; }
        }
      `}</style>
      <div className="graphics-item" dir={dir}>
        <img src={icon} alt={alt} />
        <div>
          <div className="g-title">{title}</div>
          <div className="g-desc">{description}</div>
        </div>
      </div>
    </>
  );
};

GraphicsItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dir: PropTypes.string,
  alt: PropTypes.string
};

export default GraphicsItem;
